$(function() {
  var currencies = ["AUD", "CAD", "CZK", "GBP", "HUF", "CHF", "PLN", "USD"];
  var current = 0;

  var rates;
  var graphs;

  var $currency_holder = $("#currency_holder");
  var $tabs = $(".currencies li a");

  var selectCurrentTab = function() {
    var i;
    for (i = 0; i < currencies.length; ++i) {
      if (i != current) $($tabs[i]).removeClass("selected");
      else $($tabs[i]).addClass("selected");
    }
  };

  var reloadCurrency = function(currency) {
    if (rates == undefined) {
      ajax_call(
        {
          module: "ExchangeRate",
          action: "getRates",
          type: 2
        },
        function(data) {
          rates = data;
          reloadCurrency();
        },
        "json"
      );
    } else {
      var data = rates[currencies[current]];
      $currency_holder.fadeOut("fast", function() {
        $currency_holder.html(data);
        $currency_holder.fadeIn("fast");
      });
      selectCurrentTab();
    }
  };

  $(".currencies .leftarrow").click(function() {
    current = (current - 1 + currencies.length) % currencies.length;
    reloadCurrency();
    return false;
  });

  $(".currencies .rightarrow").click(function() {
    current = (current + 1) % currencies.length;
    reloadCurrency();
    return false;
  });

  $tabs.click(function() {
    var i;
    var curr = $(this).html();

    for (i = 0; i < currencies.length; ++i) {
      if (curr == currencies[i]) {
        current = i;
        reloadCurrency();
        break;
      }
    }
    return false;
  });
});
